package com.macrofocus.eflux.time

import com.macrofocus.common.properties.MutableProperty
import com.macrofocus.eflux.LagUnit
import korlibs.time.DateTime

interface TimeTracker {
    var reset:(() -> Unit)?

    val masterDateTime: MutableProperty<DateTime>
    val displayDateTime: MutableProperty<DateTime>
    val displayDateTimeRaw: MutableProperty<String>

    val masterLagProperty: MutableProperty<Int>
    val displayLagProperty: MutableProperty<Int>
    val lagUnitProperty: MutableProperty<LagUnit>

    val minDateTime: MutableProperty<DateTime>
    val maxDateTime: MutableProperty<DateTime>

    val earliestDateTime: MutableProperty<DateTime>
    val latestDateTime: MutableProperty<DateTime>

    val nowDateTime: MutableProperty<DateTime>
    val liveProperty: MutableProperty<Boolean>
    val newProperty: MutableProperty<Boolean>

    fun setEarliestLatest(earliest: DateTime, latest: DateTime)

    /**
     * When new data are received:
     */
    fun newDataReceived(now: DateTime)

    /**
     * When data are inputted in calendar:
     */
    fun dateInputted(input: DateTime, turnLiveOff: Boolean = false, force: Boolean = false)

    /**
     * When live mode is turned on:
     */
    fun liveTurnedOn()

    /**
     * When replay mode is turned on:
     */
    fun replayTurnedOn()

    /**
     * When Time slider is moved
     */
    fun timeSliderMoved(slider: Int)

    /**
     * When Time slider is moved
     */
    fun timeSliderReleased(slider: Int)

    /**
     * On each animation step
     */
    fun stepAnimation(current: Int): Boolean
}